<iw-shared-core-notification-handler></iw-shared-core-notification-handler>
<router-outlet></router-outlet>
<div #windows></div>



